<template>
  <div>

    <!-- Data Stores Hack, need to be loaded first -->
    <ShiftStore ref="shiftStore"/>
    <!-- ///////////////////////////////////////// -->

    <h1>Shifts - Data Entry</h1>
    <div>

      <!-- <span style="float:left;">Select Date:</span> <DatePicker style="float:left;"/> -->
      <span style="float:left;">Select Date:</span> <GenericDaySelector storeName="shiftStore" style="float:left;"/>
    </div>
    <br style="clear:both;" />
    
    
    <!-- Show Data Entry: <input type="checkbox" v-model="ls.showDataEntry" />  -->
    <!-- Show Transaction Counts: <input type="checkbox" v-model="ls.showTransCounts" /> -->
    <!-- Number Of Shifts: <input v-model="ls.numOfShifts" /> -->
    <div v-for="location in $locations" :key="location">
      <ShiftTable 
        :location="location" 
        :showDataEntry="true" 
        :showTransCounts="ls.showTransCounts" 
        :numOfShifts="ls.numOfShifts" 
      />
    </div>
  </div>
</template>

<script>
import ShiftTable from '@/pages/Reports/Shifts/Components/ShiftTable.vue'
import DatePicker from '@/pages/Reports/Shifts/Components/DatePicker.vue'
import ShiftStore from '@/pages/Reports/Shifts/Stores/ShiftStore.vue'
import localstorageMixin from '@/mixins/localstorageMixin.js'

export default {
  mixins: [localstorageMixin],
  components : {DatePicker, ShiftTable, ShiftStore},
  name: 'ShiftsPage',
  provide() {
    return {
      shiftsPage: this,
      page: this,
    }
  },
  data () { return { 
    ls: {
      day: '2020-08-01',
      showDataEntry: false,
      showTransCounts: false,
      numOfShifts: 10,
    },
    } 
  },

}
</script>